module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"login":"Anmelden","followedArtists":"Deine Künstler","hi":"Hi, ","logOut":"Abmelden","followHere":"Folge {artist} hier!"},"en":{"login":"Login","followedArtists":"Your artists","hi":"Hi, ","logOut":"Log out","followHere":"Follow {artist} here!"}}')
  delete Component.options._Ctor
}
